import { useEffect } from 'react';
import { useShellPresentation } from '@/components/context/ShellPresentationContext';
import { useHub } from '@/contexts/HubContext';
import { useDemoContextLabel } from '@/lib/presentation-mode/store';

/**
 * Hook to update the document title based on the current hub context.
 * Priority: demo client > client > operator
 * Format: "Ophelos Hub · {context_name}"
 */
export function usePageTitle() {
  const { selectedOperator, selectedClient } = useHub();
  const demoLabel = useDemoContextLabel();
  const { documentTitle } = useShellPresentation();

  useEffect(() => {
    if (documentTitle) {
      document.title = documentTitle;
      return;
    }
    let contextName: string | null = null;

    if (demoLabel) {
      contextName = demoLabel;
    } else if (selectedClient) {
      contextName = selectedClient.display_name;
    } else if (selectedOperator) {
      contextName = selectedOperator.name;
    }

    // Update document title
    if (contextName) {
      document.title = `Ophelos Hub · ${contextName}`;
    } else {
      document.title = 'Ophelos Hub';
    }
  }, [selectedOperator, selectedClient, demoLabel, documentTitle]);
}
